define('jquery-private',['jquery'], function(jq) {
    return jq.noConflict(true);
});
